module.exports = __webpack_public_path__ + "static/media/family.2b62ed8e.jpg";